import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';

@Component({
    selector: 'app-ipad-pos-choice',
    standalone: true,
    imports: [FormsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './pos-choice.component.html',
})
export class IpadPosChoiceComponent {
    private router = inject(Router);
    private currentTenantService = inject(CurrentTenantService);
    private matwinsVariablesService = inject(MatwinsVariablesService);

    posList = computed(() => this.currentTenantService.currentTenant()?.pointOfServices ?? []);
    selectedPosId: number | null = null;

    onSubmit(): void {
        if (this.selectedPosId == null) return;
        const pos = this.posList().find((p: any) => p.id === this.selectedPosId);
        if (!pos) return;

        this.currentTenantService.currentPointOfService.set(pos);
        this.currentTenantService.currentPointOfServiceId.set(pos.id);
        this.matwinsVariablesService.posId = pos.id;

        const clientId = this.currentTenantService.currentClientId();
        if (clientId) {
            localStorage.setItem('ipad-client-id', clientId);
        }
        localStorage.setItem('ipad-pos-id', this.selectedPosId.toString());

        this.router.navigate(['/ipad/home']);
    }

    onCancel(): void {
        this.router.navigate(['/ipad/error']);
    }
}